var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.00005,
    height: 53,
    viewBox: "0 0 55.00005 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.56936,53c-.24121,0-.4834-.05811-.7041-.17529l-15.36523-8.16699-15.36523,8.16699c-.50391.26758-1.11816.22656-1.58203-.1084-.46387-.33447-.69629-.90381-.60059-1.46729l2.93848-17.31982L.44729,21.6665c-.40527-.39941-.5498-.99365-.37305-1.53467s.64453-.93506,1.20801-1.01758l17.18262-2.52441L26.15237.8418c.25098-.51514.77441-.8418,1.34766-.8418s1.09668.32666,1.34766.8418l7.6875,15.74805,17.18262,2.52441c.56348.08252,1.03125.47656,1.20801,1.01758s.03223,1.13525-.37305,1.53467l-12.44336,12.2627,2.93848,17.31982c.0957.56348-.13672,1.13281-.60059,1.46729-.26074.18799-.56836.28369-.87793.28369Zm-16.06934-11.54102c.24219,0,.48438.05859.7041.17529l13.37598,7.10986-2.55859-15.0835c-.08203-.48291.07715-.97559.42578-1.31934l10.85449-10.69678-14.98535-2.20166c-.49023-.07178-.91309-.38086-1.12988-.82568l-6.68652-13.69775-6.68652,13.69775c-.2168.44482-.63965.75391-1.12988.82568l-14.98535,2.20166,10.85449,10.69678c.34863.34375.50781.83643.42578,1.31934l-2.55859,15.0835,13.37598-7.10986c.21973-.1167.46191-.17529.7041-.17529Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.a607404577c6dd38dc5b7efb0337cac6.svg";
export { ForwardRef as ReactComponent };